/**
 * @generated SignedSource<<b30ed20c7bb53784e3dc871f7cecebf7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endpointId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "endpointId"
      }
    ],
    "concreteType": "Endpoint",
    "kind": "LinkedField",
    "name": "endpointById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "price",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nameUk",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tags",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "orderItemEndpointByIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "orderItemEndpointByIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d3ac92d4255ab4582232dadf2d51b92a",
    "id": null,
    "metadata": {},
    "name": "orderItemEndpointByIdQuery",
    "operationKind": "query",
    "text": "query orderItemEndpointByIdQuery(\n  $endpointId: String\n) {\n  endpointById(id: $endpointId) {\n    id\n    name\n    price\n    nameUk\n    tags\n  }\n}\n"
  }
};
})();

node.hash = "bc1d49ea414e2716aa599b0b7117f15f";

module.exports = node;
